import React, { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { BasicInput } from '@dev/ee-components';

import { ErrorSubscriberOrder } from '@/components/CampaignCreator/CampaignCreatorInterface';
import { debounce } from '@/services/tools/debounce';
import {
    getCampainCreatorStore,
    ModifyCampaignMap,
    SetCampaignErrorsSubscriber,
} from '@/store/campaignCreator/actions';
import { CampaignErrorNames } from '@/store/campaignCreator/types';
import { useGetSettingsInfo } from '../../hooks/useGetStep3Info';
import { CampaignNameSectionWrapper } from '../../../styled';

import { useCampaignScreensPathsChecker } from '../../../hooks/useCampaignScreensPathsChecker';

const id = 'campaign-creator-name-input';
export const CampaignName = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { errors } = useSelector(getCampainCreatorStore);
    const errorName = CampaignErrorNames.NAME;
    const errorShortName = CampaignErrorNames.SHORTNAME;
    const hasShortNameError = !!errors?.[errorShortName];
    const hasNameExistError = !!errors?.[errorName];
    const { campaignName } = useGetSettingsInfo();
    const [name, setName] = useState(campaignName);

    const changeCampaignName = (event: ChangeEvent<HTMLInputElement>): void => {
        const currentName = event?.currentTarget?.value || '';
        setName(currentName);

        debounce(() => {
            const modifyMap = new Map<string, any>();
            modifyMap.set('Name', currentName);
            dispatch(ModifyCampaignMap(modifyMap));
        });
    };
    const { isDetailsScreen } = useCampaignScreensPathsChecker();

    useEffect((): void => {
        dispatch(
            SetCampaignErrorsSubscriber({
                id,
                errorName,
                order: ErrorSubscriberOrder.NAME,
            })
        );
        dispatch(
            SetCampaignErrorsSubscriber({
                id,
                errorName: errorShortName,
                order: ErrorSubscriberOrder.SHORTNAME,
            })
        );
    }, []);

    return (
        <CampaignNameSectionWrapper>
            <BasicInput
                id={id}
                label={t('campaignname')}
                onChange={changeCampaignName}
                value={name}
                error={hasShortNameError || hasNameExistError}
                errorMessage={hasShortNameError ? t('campaignname5char') : t('campaignnameexist')}
                readOnly={isDetailsScreen}
            />
        </CampaignNameSectionWrapper>
    );
};
